import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConcessaoTipo } from "@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum";
import { ConcessionarioPessoaTipoVinculo } from "@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-tipo-vinculo";
import { ConcessionarioPessoaDTO } from "app/model/dtos/mob/concessionario-pessoa.dto";
import { DialogFactory } from "sol-tools-ts/dist";

@Injectable()
export class ConcessionarioPessoaBuilder {
    
    private cdConcessao: number;
    private tpVinculo: number;

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _dialogFactory: DialogFactory,
        private _router: Router
    ) {
        this.cdConcessao = this._activatedRoute.snapshot.params["cdConcessao"];
        this.tpVinculo = this._activatedRoute.snapshot.data["tpVinculo"];
    }

    build(concessionarioPessoaDTO: ConcessionarioPessoaDTO) {
        switch (concessionarioPessoaDTO.concessao.tpConcessao) {
            case ConcessaoTipo.COLETIVO_URBANO:
                this._redirectColetivoUrbano(concessionarioPessoaDTO);
                break;
            case ConcessaoTipo.COLETIVO_RURAL:
                this._redirectColetivoRural(concessionarioPessoaDTO, this.tpVinculo)
                break;
            case ConcessaoTipo.TAXI:
                this._redirectTaxi(concessionarioPessoaDTO);
                break;
            case ConcessaoTipo.MOTO_TAXI:
                this._redirectMotoTaxi(concessionarioPessoaDTO);
                break;
            case ConcessaoTipo.ESCOLAR:
                this._redirectColetivoEscolar(concessionarioPessoaDTO, this.tpVinculo)
                break;
            case ConcessaoTipo.COMPLEMENTAR:
                this._redirectTransporteComplementar(concessionarioPessoaDTO, this.tpVinculo)
                break;
            default:
                throw new Error('Tipo de concessão não identificado.')
        }
    }

    private _redirectColetivoUrbano(concessionarioPessoaDTO: ConcessionarioPessoaDTO) {
        this._dialogFactory.snack("Representante ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
        this._redirectTo(['operacao', 'coletivo-urbano', 'concessoes', this.cdConcessao, 'representante', concessionarioPessoaDTO.cdConcessionarioPessoa]);
    }

    private _redirectColetivoRural(concessionarioPessoaDTO: ConcessionarioPessoaDTO, tpVinculo: number) {
        if (tpVinculo == ConcessionarioPessoaTipoVinculo.AUXILIAR) {
            this._dialogFactory.snack("Auxiliar ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
            this._redirectTo(['atendimento', 'coletivo-rural', 'permissoes', this.cdConcessao, 'auxiliar', concessionarioPessoaDTO.cdConcessionarioPessoa]);
            return;
        }
        this._dialogFactory.snack("Representante ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
        this._redirectTo(['atendimento', 'coletivo-rural', 'permissoes', this.cdConcessao, 'representante', concessionarioPessoaDTO.cdConcessionarioPessoa]);
    }

    private _redirectTaxi(concessionarioPessoaDTO: ConcessionarioPessoaDTO) {
        this._dialogFactory.snack("Auxiliar ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
        this._redirectTo(['atendimento', 'taxi', 'permissoes', this.cdConcessao, 'auxiliar', concessionarioPessoaDTO.cdConcessionarioPessoa]);
    }
    private _redirectMotoTaxi(concessionarioPessoaDTO: ConcessionarioPessoaDTO) {
        this._dialogFactory.snack("Auxiliar ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
        this._redirectTo(['atendimento', 'mototaxi', 'permissoes', this.cdConcessao, 'auxiliar', concessionarioPessoaDTO.cdConcessionarioPessoa]);
    }

    private _redirectColetivoEscolar(concessionarioPessoaDTO: ConcessionarioPessoaDTO, tpVinculo: number){
        if(tpVinculo == ConcessionarioPessoaTipoVinculo.AUXILIAR){
            this._dialogFactory.snack("Auxiliar ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
            this._redirectTo(['atendimento', 'coletivo-escolar', 'permissoes', this.cdConcessao, 'auxiliar', concessionarioPessoaDTO.cdConcessionarioPessoa]);
            return;
        }
        this._dialogFactory.snack("Representante ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
        this._redirectTo(['atendimento', 'coletivo-escolar', 'permissoes',  this.cdConcessao, 'representante', concessionarioPessoaDTO.cdConcessionarioPessoa]);
    }

    private _redirectTransporteComplementar(concessionarioPessoaDTO: ConcessionarioPessoaDTO, tpVinculo: number) {
        if (tpVinculo == ConcessionarioPessoaTipoVinculo.AUXILIAR) {
            this._dialogFactory.snack("Auxiliar ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
            this._redirectTo(['atendimento', 'transporte-complementar', 'permissoes', this.cdConcessao, 'auxiliar', concessionarioPessoaDTO.cdConcessionarioPessoa]);
            return;
        }
        this._dialogFactory.snack("Representante ativado com sucesso!", 'OK', DialogFactory.SNACK_SUCCESS, { duration: 3000 });
        this._redirectTo(['atendimento', 'transporte-complementar', 'permissoes', this.cdConcessao, 'representante', concessionarioPessoaDTO.cdConcessionarioPessoa]);
    }

    private _redirectTo(uri: Array<any>) {
        this._router.navigateByUrl('/', { skipLocationChange: true, }).then(() => this._router.navigate(uri, {replaceUrl: true}));
    }
}